import api from '../api';

export const subscriptionService = {
    // Get student's enrolled courses
    getSubscriptions: async () => {
        try {
            const response = await api.get('/students/subscriptions');
            return response.data;
        } catch (error) {
            console.error('Error fetching enrolled courses:', error);
            throw error;
        }
    },

    // Get available courses
    getAvailableCourses: async (data) => {
        console.log('available courses data', data);
        try {
            const response = await api.post('students/subscriptions/available-courses', data);
            return response.data;
        } catch (error) {
            console.error('Error fetching available courses:', error);
            throw error;
        }
    },

    // Get available courses
    getSubjectsByLevel: async () => {
        try {
            const response = await api.get('/students/available-subjects');
            return response.data;
        } catch (error) {
            console.error('Error fetching available courses:', error);
            throw error;
        }
    },

    // Enroll in a course
    addSubscription: async (courseId) => {
        try {
            const response = await api.post('/students/subscriptions', {
                courseId
            });
            return response.data;
        } catch (error) {
            console.error('Error enrolling in course:', error);
            throw error;
        }
    },

    updateWardSubscription: async (studentId, subjectId, courseId) => {
        try {
            const response = await api.post(`/guardians/${studentId}/subjects/${subjectId}/subscription`, {
                course_id: courseId
            });
            return response.data;
        } catch (error) {
            console.error('Error updating subscription:', error);
            throw new Error(error.response?.data?.error || 'Failed to update subscription');
        }
    },

    updateAllWardSubscriptions: async (studentId, teacherId, levelId) => {
        try {
            const response = await api.post(`/guardians/${studentId}/subscriptions/bulk`, {
                teacher_id: teacherId,
                level_id: levelId
            });
            return response.data;
        } catch (error) {
            console.error('Error updating all subscriptions:', error);
            throw new Error(error.response?.data?.error || 'Failed to update all subscriptions');
        }
    },

    updateSelectedWardSubscriptions: async (studentId, subscriptions) => {
        try {
            const response = await api.post(`/guardians/${studentId}/subscriptions/selective`, {
                subscriptions
            });
            return response.data;
        } catch (error) {
            console.error('Error updating selected subscriptions:', error);
            throw new Error(error.response?.data?.error || 'Failed to update selected subscriptions');
        }
    },


    updateSubscription: async (subjectId, courseId) => {
        console.log('subjectId', subjectId);
        console.log('courseId', courseId);
        try {
            const response = await api.put(`/students/subscriptions/${subjectId}`, {
                courseId
            });
            return response.data;
        } catch (error) {
            console.error('Error updating subscription:', error);
            throw error;
        }
    },

    removeSubscription: async (subscriptionId) => {
        try {
            const response = await api.delete(`/students/subscriptions/${subscriptionId}`);
            return response.data;
        } catch (error) {
            console.error('Error removing subscription:', error);
            throw error;
        }
    },

    // Remove course enrollment
    unenrollCourse: async (slotIndex) => {
        try {
            const response = await api.post('/student/unenroll', {
                slotIndex
            });
            return response.data;
        } catch (error) {
            console.error('Error removing course:', error);
            throw error;
        }
    }
};
